<app-masterheader></app-masterheader>

<div class="wrapper">

  <app-sidebar ></app-sidebar>

<div id="content">
  <div class="container-fluid py-4" style="background-color: #ffffff;">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-dark text-white text-center py-3">
            <h4 class="mb-0"> Annual Plan of Operation</h4>
          </div>
          <div class="card-body p-4">
            <div class="custom-accordion">

    <!-- Map View Panel -->
    <div class="accordion-panel" *ngIf="isReadOnly">
      <div class="accordion-header" (click)="togglePanel('map')">
        <h5>Annual Plan Operation Details</h5>
        <span>{{ openPanels.map ? '−' : '+' }}</span>
      </div>
      <div class="accordion-content" *ngIf="openPanels.map">
        <div class="panel-content">
       <div class="row col-md-12">
              <div class="col-md-6">
                <table class="table table-striped">
                  <tbody class="custom-table">
                    <tr>
                      <td class="p-3 font-tag-style">Financial Year</td>
                      <td class="p-3 font-tag-style f-w-800">2025-2026</td>
                    </tr>
                    <tr>
                      <td class="p-3 font-tag-style">Circle</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.circleName}}</td>
                    </tr>
                    <tr>
                      <td class="p-3 font-tag-style">Division</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.divName}}</td>
                    </tr>
                    <tr *ngIf="apoRequest?.rangeName">
                      <td class="p-3 font-tag-style" >Range</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.rangeName}}</td>
                    </tr>
                    <tr>
                      <td class="p-3 font-tag-style">Major Scheme</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.schemeName}}</td>
                    </tr>
                      <tr>
                      <td class="p-3 font-tag-style">Scheme Details</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.subSchemeName}}</td>
                    </tr>
                    <tr>
                      <td class="p-3 font-tag-style">Component</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.componentName}}</td>
                    </tr>
                    <tr>
                      <td class="p-3 font-tag-style">Report</td>
                      <td class="p-3 font-tag-style f-w-800">{{apoRequest?.reportName}}</td>
                    </tr>
                    
                   
                
                  </tbody>
                </table>
              </div>
              <div class="col-md-6">
                
                  <app-apomap [mapinfo]="mapinfo" ></app-apomap>
                  <!-- <p *ngIf="!gpsCoordinates.length">No GPS coordinates available.</p> -->
                
              </div>
       </div>
       </div>
       
      </div>
    </div>

              <!-- View Form Panel -->
              <div class="accordion-panel">
                <div class="accordion-header" (click)="togglePanel('view')" *ngIf="isReadOnly">
                  <h5>Annual Plan Operation (2025-2026)</h5>
                  <span>{{ openPanels.view ? '−' : '+' }}</span>
                </div>
                <div class="accordion-content" *ngIf="openPanels.view">
                  <div class="panel-content">


                    <!-- Reactive Form for Dropdowns -->
                    <form [formGroup]="apoForm" novalidate *ngIf="!isReadOnly">
                      <!-- Scheme and Component Selection -->
                      <div class="row g-3">
                        <div class="col-md-6">
                           <div class="row align-items-center mb-3">
                            <label for="finYear" class="col-md-4 col-form-label text-md-end fw-bold text-dark">Financial Year:</label>
                            <div class="col-md-8">
                              <input type="text" [value]="yearRange"  readonly class="form-control form-control-sm">
                           
                            </div>
                          </div>

                          <div class="row align-items-center mb-3">
                            <label for="scheme" class="col-md-4 col-form-label text-md-end fw-bold text-dark">Major Scheme:</label>
                            <div class="col-md-8">
                              <select id="scheme" class="form-control form-control-sm" formControlName="scheme"
                                (change)="getAllSubSchemeDD($event.target.value)"
                                [ngClass]="{'is-invalid': apoForm.get('scheme')?.invalid && apoForm.get('scheme')?.touched}">
                                <option value="0">All Major Scheme</option>
                                <option *ngFor="let scheme of schemeList" [value]="scheme.id">
                                  {{ scheme.name }}
                                </option>
                              </select>
                              <div *ngIf="apoForm.get('scheme')?.invalid && apoForm.get('scheme')?.touched"
                                class="invalid-feedback">
                                Please select a Major Scheme.
                              </div>
                            </div>
                          </div>
                          <div class="row align-items-center mb-3">
                            <label for="scheme" class="col-md-4 col-form-label text-md-end fw-bold text-dark">Scheme Details:</label>
                            <div class="col-md-8">
                              <select id="subscheme" class="form-control form-control-sm" formControlName="subscheme"
                                (change)="getAllComponentDDByScheme($event.target.value)"
                                [ngClass]="{'is-invalid': apoForm.get('subscheme')?.invalid && apoForm.get('subscheme')?.touched}">
                                <option value="0">All Schemes</option>
                                <option *ngFor="let scheme of subSchemeList" [value]="scheme.id">
                                  {{ scheme.name }}
                                </option>
                              </select>
                              <div *ngIf="apoForm.get('subscheme')?.invalid && apoForm.get('subscheme')?.touched"
                                class="invalid-feedback">
                                Please select a scheme.
                              </div>
                            </div>
                          </div>

                          <div class="row align-items-center mb-3">
                            <label for="component"
                              class="col-md-4 col-form-label text-md-end fw-bold text-dark">Component:</label>
                            <div class="col-md-8">
                              <select id="component" class="form-control form-control-sm" formControlName="component"
                                (change)="onSelectComponent($event.target.value)"
                                [ngClass]="{'is-invalid': apoForm.get('component')?.invalid && apoForm.get('component')?.touched}">
                                <option value="0">All Component</option>
                                <option *ngFor="let component of componentList" [value]="component.id">
                                  {{ component.name }}
                                </option>
                              </select>
                              <div *ngIf="apoForm.get('component')?.invalid && apoForm.get('component')?.touched"
                                class="invalid-feedback">
                                Please select a component.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <!-- <div class="col-md-12" *ngIf="apoForm.get('component')?.value!='0'">
                      <button type="button" class="btn btn-sm btn-primary" (click)="downoladExcelForm(apoForm.get('component')?.value)">Download Excel</button>
                    </div> -->
                    <!-- Download Excel Button *ngIf="apoForm.get('component')?.value != '0' && !isReadOnly "-->
                     
                    <div class="row mt-3" *ngIf="tableData.length > 0 && !isReadOnly ">
                       <span class="col-md-1 d-flex justify-content-end  text-danger"  *ngIf="tableData.length > 0  ">*** It is Land Based Activity</span>
                      <div class="col-md-11 d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-primary me-2" 
                        (click)=" downloadAsExcel()"
                        >
                        <!-- (click)="downoladExcelForm(apoForm.get('component')?.value)" -->
                          Download Sample Excel
                        </button>
                         <button type="button" class="btn btn-sm btn-info" (click)="openExcelFormModal()" >
                          Upload Excel
                        </button>
                      </div>
                    </div>
                     
                    <!-- Template-Driven Form for Table -->
                    <form class="needs-validation" (ngSubmit)="submitData()" novalidate *ngIf="tableData.length > 0  ">
                      <!-- Report Table -->
                      <div class="table-responsive mt-4" style="max-height: 60vh; overflow-y: auto;">
                        <table class="table table-bordered">
                          <thead class="table-header sticky-top bg-dark">
                            <tr>
                              <th id="formtitle" [attr.colspan]="dynamicFields.length + 2" class="p-3 text-white">
                                {{ formTitle }} <small class="text-white-50">
                                  <pre>{{ formDesc }}</pre>
                                </small>
                              </th>
                            </tr>
                            <tr>
                              <th id="slno" rowspan="3" class="align-middle text-white">Sl. No.</th>
                              <ng-container *ngFor="let group of getHeaderGroups()">
                                <ng-container *ngIf="group.type === 'standalone'">
                                  <th [attr.rowspan]="group.fields[0].rowspan || 2" class="align-middle text-white">{{ group.name
                                    }}</th>
                                </ng-container>
                                <ng-container *ngIf="group.type === 'superGroup'">
                                  <th [attr.colspan]="calculateTotalFields(group)" class="align-middle text-white text-center">{{
                                    group.name }}</th>
                                </ng-container>
                              </ng-container>
                              <th rowspan="3" class="align-middle bg-dark text-white" *ngIf="!isViewMode && !isReadOnly">Action</th>
                            </tr>
                            <tr>
                              <ng-container *ngFor="let group of getHeaderGroups()">
                                <ng-container *ngIf="group.type === 'superGroup'">
                                  <ng-container *ngFor="let subGroup of group.subGroups || []">
                                    <th *ngIf="subGroup.name" [attr.colspan]="subGroup.fields.length"
                                      class="align-middle bg-secondary text-white text-center">{{ subGroup.name }}</th>
                                  </ng-container>
                                  <ng-container *ngIf="!group.subGroups || group.subGroups.length === 0">
                                    <th *ngFor="let field of group.fields" [attr.rowspan]="field.rowspan || 2"
                                      class="align-middle bg-dark text-white">{{ field.label }}</th>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </tr>
                            <tr>
                              <ng-container *ngFor="let group of getHeaderGroups()">
                                <ng-container *ngIf="group.type === 'superGroup'">
                                  <ng-container *ngFor="let subGroup of group.subGroups || []">
                                    <th *ngFor="let field of subGroup.fields" [attr.rowspan]="field.rowspan || 2"
                                      class="align-middle text-white">{{ field.label }}</th>
                                  </ng-container>
                                </ng-container>
                                <ng-container *ngIf="group.type === 'standalone' && group.fields[0].rowspan === 2">
                                  <th *ngFor="let field of group.fields" [attr.rowspan]="field.rowspan || 2"
                                    class="align-middle text-white">{{ field.label }}</th>
                                </ng-container>
                              </ng-container>
                            </tr>
                          </thead>

                          <tbody>
                            <!-- (click)="currentRow = row" -->
                            <tr *ngFor="let row of tableData; let i = index; trackBy: trackByIndex"  
                              [class.non-editable-bold]="row.hasChildren" (click)="onRowClick(row)">
                              <td class="fw-bold" [style.padding-left]="getIndentPadding(row)">
                                <span>{{ row.serial }}</span>
                                <span class="text-danger" *ngIf="row.islandBased"> *** </span>
                              </td>
                                <td>
                                  <span [innerHTML]="cleanItemName(row.itemName)"></span>
                                </td>
                                <ng-container *ngFor="let field of dynamicFields">
                                  <td *ngIf="field.editable">
                                     <ng-container *ngIf="isReadOnly ||!shouldShowEditableField(row) || !field.editable">
                                        <span>{{ row.data[field.name] || '' }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="shouldShowEditableField(row) && field.editable">
                                      <input *ngIf="field.type === 'number'" 
                                              type="number" class="form-control form-control-sm"
                                              [(ngModel)]="row.data[field.name]" 
                                              (ngModelChange)="updateAmountRequired(row)"
                                              [ngModelOptions]="{standalone: true}"
                                              [name]="'field_' + row.serial + '_' + field.name" 
                                              [readonly]="isReadOnly  || row.isSaved || field.name === 'amountRequired'" 
                                              step="0.01"
                                              min="0" 
                                              required 
                                              [ngClass]="{'is-invalid': showFieldError(row, field.name)}"
                                              (blur)="onFieldBlur(field.name, row)">

                                      <input *ngIf="field.type === 'text'" 
                                              type="text" class="form-control form-control-sm"
                                               [(ngModel)]="row.data[field.name]"
                                               (ngModelChange)="updateAmountRequired(row)"
                                              [ngModelOptions]="{standalone: true}" 
                                              [name]="'field_' + row.serial + '_' + field.name"
                                              [readonly]="isReadOnly || row.isSaved " 
                                              required 
                                              [ngClass]="{'is-invalid': showFieldError(row, field.name)}"
                                              (blur)="onFieldBlur(field.name, row)">

                                      <div class="dropdown-container" (click)="$event.stopPropagation()" *ngIf="field.type === 'dropdown' && (field.name === 'itemDD' ? row.dropdownOptions : row.unitDropdownOptions)?.length > 0">
                                        <select class="form-control form-control-sm dropdown-fixed-width" 
                                                [ngClass]="{'is-invalid': showFieldError(row, field.name)}"
                                                [(ngModel)]="row.data[field.name]" 
                                                [disabled]="field.name === 'itemDD' || row.isSaved"
                                                 [ngModelOptions]="{standalone: true}" 
                                               (ngModelChange)="onDropdownChange($event, row, field.name)">
                                          <option *ngFor="let option of (field.name === 'itemDD' ? row.dropdownOptions : row.unitDropdownOptions)" [value]="option.value">
                                            {{ option.label }}
                                          </option>
                                        </select>
                                        <!-- <button *ngIf="!isReadOnly && !row.isSaved" 
                                                class="btn btn-sm btn-primary ms-2 add-option-btn" 
                                                type="button"
                                                title="Add another option"
                                                 (click)="addNewRow(row);"
                                                [disabled]="row.isSaved || isReadOnly || row.dropdownOptions?.length <= 1"
                                               >
                                          <i class="fas fa-plus"></i>
                                        </button> -->
                                        <!-- <button class="btn btn-danger btn-sm" 
                                            type="button"
                                             title="Remove option"
                                             (click)="removeRow(row)"
                                          [disabled]="row.isSaved || isReadOnly || tableData.length <= 1">
                                           <i class="fa fa-times" aria-hidden="true"></i>

                                        </button> -->
                                      </div>

                                      <div *ngIf="showFieldError(row, field.name)" class="invalid-feedback">
                                        {{ getFieldError(row, field.name) }}
                                      </div>
                                    </ng-container>
                                   
                                  </td>
                                </ng-container>

                                <td class="text-nowrap" *ngIf="!isReadOnly">
                                   <!-- <button class="btn btn-sm btn-primary" *ngIf="row.editableIndex !== undefined" [disabled]="row.isSaved"
                                    (click)="openSiteSpecificationModal(row)" type="button">
                                    <i class="fas fa-info-circle"></i> Site Specification
                                  </button> -->
                                  
                                  <button *ngIf="!row.isSaved && shouldShowEditableField(row) && row.editableIndex !== undefined"
                                    class="btn btn-sm btn-success me-2" (click)="saveRow(row)" type="button">
                                    <i class="fas fa-save"></i> Save
                                  </button>

                                  <button *ngIf="row.isSaved && shouldShowEditableField(row)" class="btn btn-sm btn-warning me-2"
                                    (click)="editRow(row)" type="button">
                                    <i class="fas fa-edit"></i> Edit
                                  </button>
                                  <button *ngIf="shouldShowEditableField(row)" class="btn btn-sm btn-danger  me-2"
                                    (click)="resetRow(row)" type="button">
                                    <i class="fas fa-undo"></i> Reset
                                  </button>
                                  <!-- [disabled]="!row.isSaved" -->
                                  <div class="button-wrapper" *ngIf="row.editableIndex !== undefined">
                                    <span class="badge badge-count">
                                    {{row.siteSpecifictaionCount}}
                                    </span>
                                    <button class="btn btn-sm btn-info" (click)="openModal(row)" type="button">
                                      <i class="fas fa-info-circle"></i> Site Specification
                                    </button>
                                  </div>


                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="text-center mt-4" *ngIf="!isReadOnly">
                        <button  type="button" class="btn btn-success me-2" (click)="saveAllRows()" >Save All</button>
                        <button type="button" class="btn btn-sm btn-warning me-2" (click)="resetAllRows()" [disabled]="tableData.length===0">
                          <i class="fas fa-undo-alt"></i> Reset All
                        </button>
                        <!-- [disabled]="!allRowsSaved" -->
                        <button type="submit" class="btn btn-primary px-4">
                          Final Submit
                        </button>
                        <div *ngIf="!allRowsSaved" class="text-warning mt-2">
                          Please save all rows before submitting
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <!-- Execution Panel -->
              <!-- <div class="accordion-panel" *ngIf="isReadOnly">
                <div class="accordion-header" (click)="togglePanel('execution')">
                  <h5>Execution Documents</h5>
                  <span>{{ openPanels.execution ? '−' : '+' }}</span>
                </div>
                <div class="accordion-content" *ngIf="openPanels.execution">
                  <div class="panel-content">
                    <div class="tabs">
                      <button class="tab-button" [class.active]="activeTab === 'kml'" (click)="setActiveTab('kml')">KML File</button>
                      <button class="tab-button" [class.active]="activeTab === 'images'" (click)="setActiveTab('images')">Before/After Images</button>
                      <button class="tab-button" [class.active]="activeTab === 'plan'" (click)="setActiveTab('plan')">Plan/Estimate</button>
                      <button class="tab-button" [class.active]="activeTab === 'dpr'" (click)="setActiveTab('dpr')">DPR</button>
                      <button class="tab-button" [class.active]="activeTab === 'tender'" (click)="setActiveTab('tender')">Tender Document</button>
                      <button class="tab-button" [class.active]="activeTab === 'workorder'" (click)="setActiveTab('workorder')">Work Order</button>
                      <button class="tab-button" [class.active]="activeTab === 'completion'" (click)="setActiveTab('completion')">Completion Certificate</button>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane" *ngIf="activeTab === 'kml'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="kmlFile">Upload KML File</label>
                            <input type="file" class="form-control" id="kmlFile" formControlName="kmlFile" accept=".kml" (change)="onFileChange($event, 'kmlFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'images'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="beforeImage">Before Image</label>
                            <input type="file" class="form-control" id="beforeImage" formControlName="beforeImage" accept=".jpg,.jpeg,.png" (change)="onFileChange($event, 'beforeImage')">
                          </div>
                          <div class="form-group">
                            <label for="afterImage">After Image</label>
                            <input type="file" class="form-control" id="afterImage" formControlName="afterImage" accept=".jpg,.jpeg,.png" (change)="onFileChange($event, 'afterImage')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'plan'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="planFile">Upload Plan/Estimate</label>
                            <input type="file" class="form-control" id="planFile" formControlName="planFile" accept=".pdf" (change)="onFileChange($event, 'planFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'dpr'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="dprFile">Upload DPR</label>
                            <input type="file" class="form-control" id="dprFile" formControlName="dprFile" accept=".pdf" (change)="onFileChange($event, 'dprFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'tender'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="tenderFile">Upload Tender Document</label>
                            <input type="file" class="form-control" id="tenderFile" formControlName="tenderFile" accept=".pdf" (change)="onFileChange($event, 'tenderFile')">
                          </div>

                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'workorder'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="workOrderFile">Upload Work Order</label>
                            <input type="file" class="form-control" id="workOrderFile" formControlName="workOrderFile" accept=".pdf" (change)="onFileChange($event, 'workOrderFile')">
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" *ngIf="activeTab === 'completion'">
                        <form [formGroup]="executionForm">
                          <div class="form-group">
                            <label for="completionFile">Upload Completion Certificate</label>
                            <input type="file" class="form-control" id="completionFile" formControlName="completionFile" accept=".pdf" (change)="onFileChange($event, 'completionFile')">
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="form-actions">
                      <button class="btn btn-sm btn-primary custom-btn" >Submit</button>
                    </div>
                  </div>
                </div>
              </div> -->

               <div class="accordion-panel" *ngIf="isReadOnly">
                <div class="accordion-header" (click)="togglePanel('execution')">
                  <h5>Site Specification Documents</h5>
                  <span>{{ openPanels.execution ? '−' : '+' }}</span>
                </div>
                <div class="accordion-content" *ngIf="openPanels.execution">
                  <div class="panel-content">
                        
                 <!-- Execution Filter Form for Dropdowns --> 
                  <div class="card shadow-sm mb-4">
                    <div class="card-body">
                      <!-- Filter Section -->
                      <div class="filter-section mb-4 p-3 bg-light rounded">
                        <h5 class="filter-title mb-4 text-dark fw-semibold">
                          <i class="fa fa-filter me-2 text-primary"></i>Filter Options
                        </h5>
                        <!-- <form [formGroup]="siteSpecificationFilterForm" class="row align-items-end g-3">
                          <div class="col-md-3 col-sm-6">
                            <label for="apoId" class="form-label text-muted small">Item Name</label>
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select formControlName="apoId" placeholder="Select Item Name" class="form-control">
                              
                                <mat-option>
                                  <input
                                    matInput
                                    placeholder="Search..."
                                    (input)="filterApoItems($event)"
                                    (click)="$event.stopPropagation()"
                                    class="w-100"
                                  />
                                </mat-option>
                                <mat-option value="">All</mat-option>
                                <mat-option *ngFor="let apo of filteredApoIdItemNameList" [value]="apo.apoId">
                                  {{ apo.itemName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="documentTypeId" class="form-label text-muted small">Document Type</label>
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select formControlName="documentTypeId" placeholder="Select Document Type" class="form-control">
                                <mat-option value="">All</mat-option>
                                <mat-option *ngFor="let type of executionList" [value]="type.id">
                                  {{ type.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="fromDate" class="form-label text-muted small">From Date</label>
                            <input type="date" formControlName="fromDate" class="form-control" />
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="toDate" class="form-label text-muted small">To Date</label>
                            <input type="date" formControlName="toDate" class="form-control" />
                          </div>
                          <div class="col-md-3 d-flex align-items-end gap-2 justify-content-start">
                            <button type="button" class="btn btn-primary btn-sm me-2" (click)="applyExecutionFilter()">
                              <i class="fa fa-search me-1"></i> Search
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetExecutionFilters()">
                              <i class="fa fa-refresh me-1"></i> Reset
                            </button>
                          </div>
                        </form> -->
                        <form [formGroup]="siteSpecificationFilterForm" class="row align-items-end g-3">
                          <div class="col-md-3 col-sm-6">
                            <label for="mapId" class="form-label text-muted small">Item Name</label>
                            <select class="form-control" formControlName="mapId" (change)="getDDTypeList([($event.target.value)])">
                              <option value="">All</option>
                              <option *ngFor="let item of apoIdItemNameList" [value]="item.mapId">{{ item.itemName }}</option>
                            </select>
                          </div>
                           <div class="col-md-3 col-sm-6"  *ngIf="typeListform?.length>0">
                            <label for="typeId" class="form-label text-muted small">Type Name</label>
                            <select class="form-control" formControlName="typeId">
                              <option value="">All</option>
                              <option *ngFor="let item of typeListform" [value]="item.typeId">{{ item.ddValue }}</option>
                            </select>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <label for="documentTypeId" class="form-label text-muted small">Document Type</label>
                            <select class="form-control" formControlName="documentTypeId">
                              <option value="">All</option>
                              <option *ngFor="let type of executionList" [value]="type.id">{{ type.name }}</option>
                            </select>
                          </div>
                  
                          <div class="col-md-3 col-sm-6">
                            <label for="fromDate" class="form-label text-muted small">From Date</label>
                            <input type="date" formControlName="fromDate" class="form-control" />
                          </div>
                  
                          <div class="col-md-3 col-sm-6">
                            <label for="toDate" class="form-label text-muted small">To Date</label>
                            <input type="date" formControlName="toDate" class="form-control" />
                          </div>
                  
                          <div class="col-md-3 d-flex align-items-end  gap-2  justify-content-start">
                            <button type="button" class="btn btn-primary btn-sm me-2" (click)="applyExecutionFilter()">
                              <i class="fa fa-search me-1"></i> Search
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetExecutionFilters()">
                              <i class="fa fa-refresh me-1"></i> Reset
                            </button>
                          </div>
                  
                        </form>
                      </div>
                    </div>
                  </div>

                        <div class="card shadow-sm">
                          <div class="card-body table-responsive">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              
                                <h6 class="text-secondary m-0">
                                  <i class="fa fa-list me-2"></i> List of Records
                                </h6>
                                <button class="btn btn-success  float-right" type="button" (click)="downloadExecutionListAsExcel()">
                                  <i class="fa fa-file-excel-o me-1"></i> Excel
                                </button>
                             
                              
                            </div>
                            
                            <table class="table table-hover table-bordered " >
                              <thead class="thead-dark">
                                <tr>
                                  <th>Sl.No.</th>
                                  <th>Item Name</th>
                                  <th>Type Name</th>
                                  <th>Document Type</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>Remarks</th>
                                  <th>Reported By</th>
                                  <th>Creation Date</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let item of executionPaginatedData; let i = index">
                                  <td>{{ i + 1 }}</td>
                                  <td>{{ item.taskName }}</td>
                                  <td>{{item.typeName	}}</td>
                                  <td>{{ item.documentTypeName }}</td>
                                  <td>{{ item.latitude }}</td>
                                  <td>{{ item.longitude }}</td>
                                  <td>{{ item.remarks }}</td>
                                  <td>{{ item.createdBy }}</td>
                                  <td>{{ item.creationDate | date:'mediumDate' }}</td>
                                  <td class="action-buttons">
                                    <button type="button" class="btn btn-sm btn-primary custom-btn" (click)="viewSiteDocument(item)">
                                      <i class="fas fa-eye me-2 mb-2"></i> View
                                    </button>
                                    <!-- <button type="button" class="btn btn-sm btn-info custom-btn" (click)="DownloadFile(item)">
                                      <i class="fas fa-eye me-1"></i> Download
                                    </button> -->
                                  </td>
                                </tr>
                                <tr *ngIf="executionPaginatedData.length === 0">
                                  <td colspan="9" class="text-center">No records found.</td>
                                </tr> 
                              </tbody>
                            </table>
                  
                            <!-- Pagination -->
                             <nav *ngIf="executionCurrentPage > 1" aria-label="Page navigation example">
                              <ul class="pagination justify-content-center">
                                <li class="page-item" [class.disabled]="executionCurrentPage === 1">
                                  <a class="page-link" (click)="changePage(executionCurrentPage - 1)">Previous</a>
                                </li>
                  
                                <li class="page-item" *ngFor="let page of executionPagesArray" [class.active]="page === executionCurrentPage">
                                  <a class="page-link" (click)="changePage(page)">{{ page }}</a>
                                </li>
                  
                                <li class="page-item" [class.disabled]="executionCurrentPage === executionTotalPages">
                                  <a class="page-link" (click)="changePage(executionCurrentPage + 1)">Next</a>
                                </li>
                              </ul>
                            </nav> 
                  
                          </div>
                        </div>
                  
                  </div>
                </div>
              </div>

          


          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal for Additional Information -->
 <div class="modal fade modern-modal " [class.show]="isModalOpen" [style.display]="isModalOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="additionalInfoModal" [attr.aria-hidden]="!isModalOpen">
  <div class="modal-dialog  modal-xl">
    <div class="modal-content">
      <div class="modal-header modern-header">
        <h5 class="modal-title bold-text" id="additionalInfoModal">Site Specification 
           <span class="text-muted-1  me-auto" *ngIf="currentRow?.data['unitDD'] === '3' ||  currentRow?.data['unitPrev'] == '3' || currentRow?.data['unitCurr'] == '3'">
          [ Total Sites: <span class="badge bg-info">{{ sites.length }}</span>
          / Required: <span class="badge bg-warning">{{ (currentRow?.data['quantity'] || currentRow?.data['physicalTarget'] ||  currentRow?.data['physicalTargetPrev'] || currentRow?.data['physicalTargetCurr'] )- (currentRow?.siteSpecifictaionCount) || 0 }}</span>
           ]
        </span>
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">X</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="modalForm" class="needs-validation" novalidate>
          <!-- Remarks/Justification -->
          <div class="card mb-3 shadow-sm">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">1. Remarks/Justification</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="remarks" class="form-label bold-text">Remarks/Justification</label>
                  <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                            maxlength="300" rows="4" placeholder="Enter your remarks (max 300 characters)"
                            (input)="updateCharCount()"
                            [ngClass]="{'is-invalid': modalForm.get('remarks')?.invalid && modalForm.get('remarks')?.touched}">
                  </textarea>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="text-muted">Character count: {{ modalForm.get('remarks')?.value?.length || 0 }} / 300</small>
                    <small *ngIf="modalForm.get('remarks')?.value?.length > 300" class="text-danger">Character limit exceeded!</small>
                  </div>
                  <div *ngIf="modalForm.get('remarks')?.invalid && modalForm.get('remarks')?.touched" class="invalid-feedback">
                    Remarks must be between 1 and 300 characters.
                  </div>
                </div>
                <div class="col-md-12 text-end">
                  <button type="button" class="btn btn-sm btn-danger" (click)="resetRemarks()">Reset</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Map View Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">2. Map View</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="kmlFile" class="form-label bold-text">Geography (KML File)
                    <span class="text-danger bold-text" *ngIf="currentRow?.islandBased">*  ***KML file is Mandatory for Land Based Activity</span>
                    <small id="kmlFileHelp2" class="form-text text-muted text-danger" *ngIf="currentRow?.islandBased"></small>
                    
                  </label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="kmlFile" formControlName="kmlFile" accept=".kml"
                      (change)="onKmlFileChange($event)" aria-describedby="kmlFileHelp">
                    <span class="file-name">{{ modalForm.get('kmlFile')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('kmlFile')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('kmlFile')?.errors?.invalidType }}
                  </div>
                  <small id="kmlFileHelp" class="form-text text-muted">Upload a .kml file for geographic data.</small>
                  <button type="button" class="btn btn-danger" (click)="unloadKMLFile()">Cancel</button>
                </div>
              </div>
              <!-- Map View Preview Subsection -->
              <div class="preview-subsection mb-4">
                <h6 class="bold-text mb-2">Map View Preview</h6>
                <div *ngIf="!modalForm.get('kmlFile')?.value" class="text-muted">No KML file selected.</div>
                <!-- <app-map-preview *ngIf="modalForm.get('kmlFile')?.value" [kmlFile]="modalForm.get('kmlFile')?.value"></app-map-preview> -->
                     <app-map-preview *ngIf="kmlFile" [kmlFile]="kmlFile"></app-map-preview>
              </div>
            </div>
          </div>

          <!-- Images Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">3. Images</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="beforeImage" class="form-label bold-text">Before Image</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="beforeImage" formControlName="beforeImage"
                      accept=".jpg,.jpeg,.png" (change)="onBeforeImageChange($event)" aria-describedby="beforeImageHelp">
                    <span class="file-name">{{ modalForm.get('beforeImage')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('beforeImage')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('beforeImage')?.errors?.invalidType }}
                  </div>
                  <small id="beforeImageHelp" class="form-text text-muted">Upload a GeoTag .jpg or .png image.</small>
                  <button class="btn btn-danger" (click)="unloadBeforeImage()">Cancel</button>
                  <!-- Images Preview Subsection -->
                  <div class="preview-subsection mb-4">
                    <p class="mb-1 small bold-text">Before Image:</p>
                    <div *ngIf="!beforeImagePreview" class="text-muted">No Before Image selected.</div>
                    <div *ngIf="geoTagBeforeImgCoord" class="coordinates-container">
                      <div class="coordinates-badge">
                        <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                        <span class="coord-label">Lat:</span> {{ geoTagBeforeImgCoord?.latitude.toFixed(6) }},
                        <span class="coord-label ms-3">Lon:</span> {{ geoTagBeforeImgCoord?.longitude.toFixed(6) }}
                      </div>
                    </div>
                    <img *ngIf="beforeImagePreview" [src]="beforeImagePreview" alt="Before Image Preview" class="img-thumbnail"
                      style="max-height: 150px; max-width: 100%;">
                  </div>
                </div>
                <!-- <div class="col-md-6 mb-3">
                  <label for="afterImage" class="form-label bold-text">After Image</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="afterImage" formControlName="afterImage"
                      accept=".jpg,.jpeg,.png" (change)="onAfterImageChange($event)" aria-describedby="afterImageHelp">
                    <span class="file-name">{{ modalForm.get('afterImage')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('afterImage')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('afterImage')?.errors?.invalidType }}
                  </div>
                  <small id="afterImageHelp" class="form-text text-muted">Upload a GeoTag .jpg or .png image.</small>
                  <button class="btn btn-danger" (click)="unloadAfterImage()">Cancel</button>
                  <div class="preview-subsection mb-4">
                    <p class="mb-1 small bold-text">After Image:</p>
                    <div *ngIf="!afterImagePreview" class="text-muted">No After Image selected.</div>
                    <div *ngIf="geoTagAfterImgCoord" class="coordinates-container">
                      <div class="coordinates-badge">
                        <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                        <span class="coord-label">Lat:</span> {{ geoTagAfterImgCoord?.latitude.toFixed(6) }},
                        <span class="coord-label ms-3">Lon:</span> {{ geoTagAfterImgCoord?.longitude.toFixed(6) }}
                      </div>
                    </div>
                    <img *ngIf="afterImagePreview" [src]="afterImagePreview" alt="After Image Preview" class="img-thumbnail"
                      style="max-height: 150px; max-width: 100%;">
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <!-- Documents Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0 bold-text">4. Documents</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label for="pdfFile" class="form-label bold-text">Supportive Document</label>
                  <div class="file-upload-wrapper">
                    <input type="file" class="form-control modern-input" id="pdfFile" formControlName="pdfFile" accept=".pdf"
                      (change)="onPdfFileChange($event)" aria-describedby="pdfFileHelp">
                    <span class="file-name">{{ modalForm.get('pdfFile')?.value?.name || 'No file chosen' }}</span>
                  </div>
                  <div *ngIf="modalForm.get('pdfFile')?.errors?.invalidType" class="invalid-feedback d-block">
                    {{ modalForm.get('pdfFile')?.errors?.invalidType }}
                  </div>
                  <small id="pdfFileHelp" class="form-text text-muted">Upload a .pdf document.</small>
                  <button class="btn btn-danger" (click)="unloadPdfFile()">Cancel</button>
                  <!-- Documents Preview Subsection -->
                  <div class="preview-subsection">
                    <h6 class="bold-text mb-2">Documents Preview</h6>
                    <div *ngIf="!pdfPreviewUrl" class="text-muted">No PDF file selected.</div>
                    <div *ngIf="pdfPreviewUrl">
                      <p class="mb-1 small bold-text">Supportive Document:</p>
                      <a [href]="pdfPreviewUrl" target="_blank" class="text-primary">{{ this.pdfFile.name }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Button -->
          <!-- <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-success modern-btn" (click)="addSite()">Add Site</button>
          </div> -->
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <span class="text-muted modern-text-muted">
                Total Sites Added: <span class="badge bg-info">{{ sites.length }}</span>
              </span>
            </div>
            <button type="button" class="btn modern-btn btn-success"
            [disabled]="(selectedRow?.data['unitDD'] === '3' && (selectedRow?.data['quantity']  || selectedRow?.data['physicalTarget'] ||  selectedRow?.data['physicalTargetPrev'] || selectedRow?.data['physicalTargetCurr'] )- (selectedRow?.siteSpecifictaionCount) || 0) > 0 && sites.length == ((selectedRow?.data['quantity'] || selectedRow?.data['physicalTarget'] ||  selectedRow?.data['physicalTargetPrev'] || selectedRow?.data['physicalTargetCurr'])- (selectedRow?.siteSpecifictaionCount) || 0)"
             (click)="addSite()">
              <i class="bi bi-plus-circle me-1"></i>Add Site
            </button>
          </div>

        </form>

        <!-- List of Saved Sites -->
        <div class="saved-sites-list">
          <h5 class="bold-text mb-3">Sites to Submit</h5>
          <div *ngIf="sites.length === 0" class="text-muted">No sites added yet.</div>
          <div class="card mb-2" *ngFor="let site of sites; let i = index">
            <div class="card-body">
              <h2 class="bold-text text-center">Site-{{ i + 1 }}</h2>
              <p><strong>Remarks:</strong> {{ site.remarks }}</p>
              <p><strong>KML File:</strong> {{ site.kmlFile?.name || 'None' }}</p>
              <p><strong>Before Image:</strong> {{ site.beforeImage?.name || 'None' }}</p>
              <div *ngIf="site.geoTagBeforeImgCoord" class="coordinates-container">
                <div class="coordinates-badge">
                  <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                  <span class="coord-label">Lat:</span> {{ site.geoTagBeforeImgCoord?.latitude.toFixed(6) }},
                  <span class="coord-label ms-3">Lon:</span> {{ site.geoTagBeforeImgCoord?.longitude.toFixed(6) }}
                </div>
              </div>
              <img *ngIf="site.beforeImagePreview" [src]="site.beforeImagePreview" alt="Before Image Preview" class="img-thumbnail"
                style="max-height: 100px; max-width: 100px;">
              <!-- <p><strong>After Image:</strong> {{ site.afterImage?.name || 'None' }}</p>
              <div *ngIf="site.geoTagAfterImgCoord" class="coordinates-container">
                <div class="coordinates-badge">
                  <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                  <span class="coord-label">Lat:</span> {{ site.geoTagAfterImgCoord?.latitude.toFixed(6) }},
                  <span class="coord-label ms-3">Lon:</span> {{ site.geoTagAfterImgCoord?.longitude.toFixed(6) }}
                </div>
              </div>
              <img *ngIf="site.afterImagePreview" [src]="site.afterImagePreview" alt="After Image Preview" class="img-thumbnail"
                style="max-height: 100px; max-width: 100px;"> -->
              <p><strong>PDF Document:</strong> {{ site.pdfFile?.name || 'None' }}</p>
              <a *ngIf="site.pdfPreviewUrl" [href]="site.pdfPreviewUrl" target="_blank" class="text-primary">View PDF</a>
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeSite(i)">Remove</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="modal-footer modern-footer">
        <button type="button" class="btn btn-secondary modern-btn" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary modern-btn" (click)="saveSiteInfo()">Submit All Sites</button>
      </div> -->
        <div class="modal-footer modern-footer">
          <span class="text-muted modern-text-muted me-auto" *ngIf="currentRow?.data['unitDD'] === '3'  ||  currentRow?.data['unitPrev'] == '3' || currentRow?.data['unitCurr'] == '3'">
          Total Sites: <span class="badge bg-info">{{ sites.length }}</span>
          / Required: <span class="badge bg-warning">{{ (currentRow?.data['quantity'] || currentRow?.data['physicalTarget']  || currentRow?.data['physicalTargetPrev'] || currentRow?.data['physicalTargetCurr']  )- (currentRow?.siteSpecifictaionCount) || 0 }}</span>
        </span>
          <button type="button" class="btn btn-secondary modern-btn" (click)="closeModal()">
            <i class="bi bi-x-circle me-1"></i>Cancel
          </button>
          <button type="button" class="btn btn-primary  modern-btn"  (click)="saveAllSiteInfo()">
            <i class="bi bi-check-circle me-1"></i>Submit All Sites
          </button>
          <!-- [disabled]="(currentRow?.data['quantity'] || 0) > 0 && sites.length !== (currentRow?.data['quantity'] || 0)" -->
        </div>
    </div>
  </div>
</div>




   <!-- Modal for Site Specification NOT IN USED -->
    <div class="modal fade modern-modal" [class.show]="isModalSiteSpecificationOpen" [style.display]="isModalSiteSpecificationOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="additionalSiteModal" [attr.aria-hidden]="!isModalSiteSpecificationOpen">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header modern-header">
            <h5 class="modal-title bold-text" id="additionalSiteModal">Site Specification</h5>
            <button type="button" class="btn-close" (click)="closeSiteSpecificationModal()" aria-label="Close">X</button>
          </div>

          <div class="modal-body">
            <form [formGroup]="siteSpecificationForm" class="needs-validation" novalidate >
              <!-- Remarks/Justification -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">1. Remarks/Justification</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label for="remarks" class="form-label bold-text">Remarks/Justification</label>
                      <!-- <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                                maxlength="1500" rows="4" placeholder="Enter your remarks (max 300 words)"
                                (input)="updateWordCount()"
                                [ngClass]="{'is-invalid': siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched}">
                      </textarea>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">Word count: {{ wordCount }} / 300</small>
                        <small *ngIf="wordCount > 300" class="text-danger">Word limit exceeded!</small>
                      </div> -->
                        <textarea class="form-control form-control-sm" id="remarks" formControlName="remarks"
                                maxlength="300" rows="4" placeholder="Enter your remarks (max 300 characters)"
                                (input)="updateCharCount()"
                                [ngClass]="{'is-invalid': siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched}">
                      </textarea>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">Character count: {{ charCount }} / 300</small>
                        <small *ngIf="charCount > 300" class="text-danger">Character limit exceeded!</small>
                      </div>
                      <div *ngIf="siteSpecificationForm.get('remarks')?.invalid && siteSpecificationForm.get('remarks')?.touched" class="invalid-feedback">
                        Remarks must be between 1 and 300 words.
                      </div>
                    </div>
                    <div class="col-md-12 text-end">
                      <button type="button" class="btn btn-sm btn-danger" (click)="resetRemarks()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Images Section -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">2. Geotagged Images</h6>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <label for="siteImage" class="form-label bold-text">Upload Geotagged Images</label>
                      <div class="file-upload-wrapper d-flex align-items-center">
                        <input type="file" class="form-control modern-input me-2" id="siteImage" accept=".jpg,.jpeg,.png"
                               (change)="onSiteImageChange($event)" aria-describedby="siteImageHelp"  [disabled]="siteImages.length >= 5">
                        <button type="button" class="btn btn-sm btn-primary" 
                                [disabled]="!tempSiteImage || siteImages.length >= 5 || !tempSiteImageCoordinates">
                          Add Image
                        </button>
                      </div>
                      <small id="siteImageHelp" class="form-text text-muted">Upload a geotagged .jpg or .png image (max 5 images).Image must contain geotag data.</small>
                      <div *ngIf="siteImages.length >= 5" class="text-warning mt-1">
                        Maximum of 5 images reached.
                      </div>
                      <div *ngIf="tempSiteImage && !tempSiteImageCoordinates" class="text-danger mt-1">
                        Selected image does not contain geotag data.
                      </div>
                    </div>
                  </div>

                  <!-- Image Previews -->
                  <div class="row" *ngIf="siteImages.length > 0">
                    <div class="col-md-12">
                      <h6 class="bold-text mb-2">Uploaded Images</h6>
                      <div class="image-preview-container d-flex flex-wrap gap-3">
                        <div *ngFor="let image of siteImages; let i = index; trackBy: trackByIndex" 
                        class="image-preview-card position-relative  d-flex flex-column align-items-center">
                             <div *ngIf="image.coordinates" class="coordinates-badge mb-1 text-center">
                            <i class="bi bi-geo-alt-fill me-1 text-primary"></i>
                            <span class="coord-label">Lat:</span> {{ image.coordinates.latitude.toFixed(6) }},
                            <span class="coord-label ms-2">Lon:</span> {{ image.coordinates.longitude.toFixed(6) }}
                          </div>
                           <div class="position-relative">
   <img [src]="image.previewUrl" alt="Site Image Preview" class="img-thumbnail"
                               style="max-height: 120px; max-width: 120px; object-fit: cover;">
                       
                          <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
                                  (click)="removeSiteImage(i)" title="Remove Image">
                            <i class="fas fa-times"></i>
                          </button>
                           </div>
                       
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="siteImages.length === 0" class="text-muted">
                    No images uploaded yet.
                  </div>
                </div>
              </div>

              <!-- Documents Section -->
              <div class="card mb-3 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0 bold-text">3. Supportive Documents</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label for="supportiveDocument" class="form-label bold-text">Supportive Document</label>
                      <div class="file-upload-wrapper">
                        <input type="file" class="form-control modern-input" id="supportiveDocument" formControlName="supportiveDocument"
                               accept=".pdf,.doc,.docx" (change)="onSupportiveDocumentChange($event)" aria-describedby="supportiveDocumentHelp">
                        <span class="file-name">{{ siteSpecificationForm.get('supportiveDocument')?.value?.name || 'No file chosen' }}</span>
                      </div>
                      <div *ngIf="siteSpecificationForm.get('supportiveDocument')?.errors?.invalidType" class="invalid-feedback d-block">
                        {{ siteSpecificationForm.get('supportiveDocument')?.errors?.invalidType }}
                      </div>
                      <small id="supportiveDocumentHelp" class="form-text text-muted">Upload a .pdf, .doc, or .docx document.</small>
                      <button type="button" class="btn btn-sm btn-danger mt-2" (click)="unloadSupportiveDocument()">Cancel</button>
                      <div class="preview-subsection mt-3">
                        <h6 class="bold-text mb-2">Document Preview</h6>
                        <div *ngIf="!supportiveDocumentPreviewUrl" class="text-muted">No document selected.</div>
                        <div *ngIf="supportiveDocumentPreviewUrl">
                          <p class="mb-1 small bold-text">Supportive Document:</p>
                          <a [href]="supportiveDocumentPreviewUrl" target="_blank" class="text-primary">
                            {{ supportiveDocumentFile.name }}
                          </a>
                        </div>

                   

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer modern-footer">
            <button type="button" class="btn btn-secondary modern-btn" (click)="closeSiteSpecificationModal()">Cancel</button>
            <button type="button" class="btn btn-primary modern-btn" (click)="saveSiteSpecification()">
              Save
            </button>
          </div>

       
        </div>
      </div>
    </div>
  <!-- Modal for Image View -->
  <div class="modal fade modern-modal" [class.show]="isImageModalOpen">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header modern-header">
          <h5 class="modal-title bold-text">View Image</h5>
          <button type="button" class="btn-close" (click)="closeImageModal()">X</button>
        </div>
        <div class="modal-body">
          <img [src]="selectedImagePath" alt="Document Image" class="img-fluid document-preview" *ngIf="selectedImagePath">
        </div>
        <div class="modal-footer modern-footer">
          <button type="button" class="btn btn-sm btn-secondary custom-btn modern-btn" (click)="closeImageModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
   <!-- Modal for Map View -->
  <div class="modal fade modern-modal" [class.show]="isMapModalOpen">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header modern-header">
          <h5 class="modal-title bold-text">Mapview</h5>
          <button type="button" class="btn-close" (click)="closeMapModal()">X</button>
        </div>
        <div class="modal-body" style="min-height: 100%; padding: 0;">
              <app-apogeometrymapview *ngIf="mapPreviewGeojsonInfo" [mapPreviewGeojsonInfo]="mapPreviewGeojsonInfo"></app-apogeometrymapview>
          
        </div>
        <div class="modal-footer modern-footer">
          <button type="button" class="btn btn-sm btn-secondary custom-btn modern-btn" (click)="closeMapModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Upload Excel Modal -->
<div class="modal" [ngClass]="{'show d-block': isUploadExcelModalOpen}" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header  modern-header">
         <h5 class="modal-title bold-text">Upload Excel File</h5>
          <button type="button" class="btn-close" (click)="closeUploadExcelModal()">X</button>
       
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="uploadExcelModal">Select Excel File</label>
          <input type="file" class="form-control" id="uploadExcelModal" accept=".xlsx,.xls" (change)="onExcelFileChange($event)" [disabled]="isLoading">
          <small class="form-text text-muted">Only .xlsx and .xls files are allowed.</small>
          <div *ngIf="selectedExcelFile" class="mt-2">
            <p>Selected file: {{ selectedExcelFile.name }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="uploadExcelForm()" [disabled]="!selectedExcelFile || isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Upload
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeUploadExcelModal()" >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

</div>

  <div id="footer">
    <app-masterfooter></app-masterfooter>
  </div>

</div>